import { useState } from "react";
import "../styles/sections/Contact.css"
import { Container, Row, Col } from "react-bootstrap";
import contactImg from "../assets/img/contact-img.svg";
import emailjs from "emailjs-com";
import { Linkedin } from "react-bootstrap-icons";
import 'animate.css';
import TrackVisibility from 'react-on-screen';

emailjs.init(process.env.REACT_APP_EMAILJS_USER_ID);

export const Contact = () => {
  const formInitialDetails = {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    message: ''
  };
  const [formDetails, setFormDetails] = useState(formInitialDetails);
  const [buttonText, setButtonText] = useState('Send');
  const [status, setStatus] = useState({});

  const onFormUpdate = (category, value) => {
    setFormDetails({
      ...formDetails,
      [category]: value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setButtonText("Sending...");

    // Use EmailJS to send form data
    emailjs.send(
      process.env.REACT_APP_EMAILJS_SERVICE_ID, // Service ID from .env
      process.env.REACT_APP_EMAILJS_TEMPLATE_ID, // Template ID from .env
      formDetails,
      process.env.REACT_APP_EMAILJS_USER_ID // User ID from .env
    )
      .then((response) => {
        console.log("SUCCESS!", response.status, response.text);
        setStatus({ success: true, message: "Message sent successfully!" });
        setFormDetails(formInitialDetails);
      })
      .catch((err) => {
        console.error("FAILED...", err);
        setStatus({ success: false, message: "Failed to send the message. Please try again." });
      })
      .finally(() => {
        setButtonText("Send");
      });
  };

  return (
    <section className="contact" id="connect">
      <Container>
        <Row className="align-items-center">
          <Col size={12} md={6}>
            <TrackVisibility>
              {({ isVisible }) =>
                <img className={isVisible ? "animate__animated animate__zoomIn" : ""} src={contactImg} alt="Contact Us" />
              }
            </TrackVisibility>
          </Col>
          <Col size={12} md={6}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                  <h2>Get in Touch!</h2>
                  <h3>Have a question, a project idea, or looking for guidance as a student? Send a message—I’ll get back to you as soon as possible.</h3>
                  <div className="linkedin-cta">
                    <a
                      href="https://www.linkedin.com/in/arash-esf/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="linkedin-glass-button"
                      aria-label="Get in touch on LinkedIn"
                    >
                      <span className="linkedin-icon-wrap">
                        <Linkedin size={20} />
                      </span>
                      <span className="linkedin-text-wrap">
                        <span className="linkedin-eyebrow">Quick Connect</span>
                        <span className="linkedin-main">Message me on LinkedIn</span>
                      </span>
                      <span className="linkedin-glow-dot" aria-hidden="true"></span>
                    </a>
                  </div>
                  <hr />
                  <form onSubmit={handleSubmit}>
                    <Row>
                      <Col size={12} sm={6} className="px-1">
                        <input
                          type="text"
                          name="firstName"
                          value={formDetails.firstName}
                          placeholder="First Name"
                          onChange={(e) => onFormUpdate('firstName', e.target.value)}
                          required
                        />
                      </Col>
                      <Col size={12} sm={6} className="px-1">
                        <input
                          type="text"
                          name="lastName"
                          value={formDetails.lastName}
                          placeholder="Last Name"
                          onChange={(e) => onFormUpdate('lastName', e.target.value)}
                          required
                        />
                      </Col>
                      <Col size={12} sm={6} className="px-1">
                        <input
                          type="email"
                          name="email"
                          value={formDetails.email}
                          placeholder="Email Address"
                          onChange={(e) => onFormUpdate('email', e.target.value)}
                          required
                        />
                      </Col>
                      <Col size={12} sm={6} className="px-1">
                        <input
                          type="tel"
                          name="phone"
                          value={formDetails.phone}
                          placeholder="Phone No."
                          onChange={(e) => onFormUpdate('phone', e.target.value)}
                        />
                      </Col>
                      <Col size={12} className="px-1">
                        <textarea
                          rows="6"
                          name="message"
                          value={formDetails.message}
                          placeholder="Message"
                          onChange={(e) => onFormUpdate('message', e.target.value)}
                          required
                        ></textarea>
                        <button type="submit"><span>{buttonText}</span></button>
                      </Col>
                      {status.message && (
                        <Col>
                          <p className={status.success === false ? "danger" : "success"}>
                            {status.message}
                          </p>
                        </Col>
                      )}
                    </Row>
                  </form>
                </div>
              }
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
